"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function promisifyEventEmitter(event, result) {
    return new Promise((resolve, reject) => {
        event.on('end', () => resolve(result));
        event.on('error', reject);
    });
}
function arrayifyStream(stream) {
    const array = [];
    return promisifyEventEmitter(stream.on('data', data => array.push(data)), array);
}
exports.default = arrayifyStream;
//# sourceMappingURL=index.js.map